import { __assign } from 'tslib';
import * as React from 'react';
import { UitkInput } from './uitk-input.esm.js';
var UitkNumberInput = function (props) {
  return React.createElement(UitkInput, __assign({}, props, {
    type: "number"
  }));
};
export { UitkNumberInput };